const MenuLink = [

  // HEADER
  {
    position: "Header",
    section: null,
    order: 0,
    text: "Property",
    href: "/property-collection",
    show: true,
    class: "link-header lineEffect",
    target: "_self",
    anchor: false
  },
  {
    position: "Header",
    section: null,
    order: 1,
    text: "Experiences",
    href: "/experiences",
    show: true,
    class: "link-header lineEffect",
    target: "_self",
    anchor: false
  },
  {
    position: "Header",
    section: null,
    order: 2,
    text: "Weddings",
    href: "/weddings",
    show: true,
    class: "link-header lineEffect",
    target: "_self",
    anchor: false
  },
  {
    position: "Header",
    section: null,
    order: 3,
    text: "Contact",
    href: "/contact-us",
    show: true,
    class: "link-header lineEffect",
    target: "_self",
    anchor: false
  },

  // FOOTER
  {
    position: "Footer",
    section: "Services",
    order: 1,
    text: "Property Collection",
    href: "/property-collection",
    show: true,
    class: "link-footer lineEffect",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Services",
    order: 2,
    text: "Experiences",
    href: "/experiences",
    show: true,
    class: "link-footer lineEffect",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Services",
    order: 3,
    text: "Weddings",
    href: "/weddings",
    show: true,
    class: "link-footer lineEffect",
    target: "_self",
    anchor: false
  },


  {
    position: "Footer",
    section: "Experiences",
    order: 1,
    text: "Culinary Experiences",
    href: "/experiences/culinary-experiences",
    show: true,
    class: "link-footer lineEffect ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Experiences",
    order: 3,
    text: "Boat Charters",
    href: "/experiences/cruise",
    show: true,
    class: "link-footer lineEffect ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Experiences",
    order: 2,
    text: "Cultural Activities",
    href: "/experiences/activity",
    show: true,
    class: "link-footer lineEffect ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "LegalArea",
    order: 1,
    text: "Terms & Conditions",
    href: "/terms-conditions",
    show: true,
    class: "link-footer lineEffect ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "LegalArea",
    order: 2,
    text: "Property Rules",
    href: "/property-rules",
    show: true,
    class: "link-footer lineEffect ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "LegalArea",
    order: 3,
    text: "Gente di mare s.r.l. P.IVA IT04831951217",
    href: null,
    show: true,
    class: "link-footer ",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Copyright",
    order: 1,
    text: "Privacy Policy",
    href: "/privacy-policy",
    show: true,
    class: "textCopyright lineEffect me-5",
    target: "_self",
    anchor: false
  },
  {
    position: "Footer",
    section: "Copyright",
    order: 2,
    text: "Cookie Preferences",
    href: "/cookie",
    show: true,
    class: "textCopyright lineEffect",
    target: "_self",
    anchor: false
  }
];

export default MenuLink;